import {
  WSActions,
  WSForm,
  WSInputMask,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { MfaFactorType } from "@wingspanhq/wingspan-api-sdk";
import { ErrorAlert } from "@components/ErrorAlert";
import React from "react";
import * as Yup from "yup";
import { mfaFactorVerifyPrompt } from "./mfaFactorEnroll";

type FormData = { code: string };

type Props = {
  type: MfaFactorType;
  destination: string;
  submitting: boolean;
  error?: unknown;
  onSubmit: (code: string) => void;
  onBack: () => void;
};

const validationSchema = Yup.object().shape({
  code: Yup.string()
    .required("Verification code is required")
    .matches(/^\d{6}$/, "Enter the 6-digit code")
});

export const MfaFactorVerifyForm: React.FC<Props> = props => (
  <WSForm<FormData>
    onSubmit={data => props.onSubmit(data.code)}
    validationSchema={validationSchema}
    defaultValues={{ code: "" }}
  >
    <WSList gap="XL">
      <WSText color="gray600">
        {mfaFactorVerifyPrompt(props.type, props.destination)}
      </WSText>

      <WSForm.Field
        name="code"
        label="Verification code"
        component={WSInputMask}
        componentProps={{
          mask: "999999",
          slotChar: "",
          autoComplete: "one-time-code"
        }}
      />

      <ErrorAlert error={props.error} context="MfaFactor" />

      <WSActions
        buttons={[
          {
            kind: "Secondary",
            label: "Back",
            type: "button",
            onClick: props.onBack
          },
          {
            label: "Verify",
            type: "submit",
            loading: props.submitting
          }
        ]}
      />
    </WSList>
  </WSForm>
);
